import Chatbot from "../../features/Chatbot/Chatbot";
import App from "../../App";
import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom";
import Profile from "../../features/Profile/Profile";
import Dashboard from "../../features/Dashboard/Dashboard";
import SignUp from "../../features/UserAuthentication/SignUp";
import LogIn from "../../features/UserAuthentication/LogIn";
import EditInfo from "../../features/Profile/EditInfo";
import ResetPassword from "../../features/Profile/ResetPassword";
import TwoFactorAuthentication from "../../features/UserAuthentication/TwoFactorAuthentication";
import ActivateAccount from "../../features/UserAuthentication/ActivateAccount";
import ForgotPassword from "../../features/UserAuthentication/ForgotPassword";
import ResetForgotPassword from "../../features/UserAuthentication/ResetForgotPassword";
import NotActivated from "../../features/UserAuthentication/NotActivated";
import ProtectedRoute from "./protectedRoute";
import VerifyEmail from "../../features/Profile/VerifyEmail";
import NotFound from "../layout/NotFound";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <App />,            // App must render <Outlet />
    children: [
      // DEFAULT (index) route
      { index: true, element: <Navigate to="/dashboard" replace /> },

      // Public/auth routes
      { path: "sign-up", element: <SignUp /> },
      { path: "log-in", element: <LogIn /> },
      { path: "2fa", element: <TwoFactorAuthentication /> },
      { path: "activate", element: <ActivateAccount /> },
      { path: "not-activated", element: <NotActivated /> },
      { path: "forgot-password", element: <ForgotPassword /> },
      { path: "reset-forgot-password", element: <ResetForgotPassword /> },

      // Protected routes
      {
        element: <ProtectedRoute />,
        children: [
          { path: "profile", element: <Profile /> },
          { path: "profile/edit-info", element: <EditInfo /> },
          { path: "profile/reset-password", element: <ResetPassword /> },
          { path: "profile/verify-new-email", element: <VerifyEmail /> },
          { path: "dashboard", element: <Dashboard /> },
          { path: "chatbot", element: <Chatbot /> },
          { path: "chatbot/:sessionId", element: <Chatbot /> },
        ],
      },

      // Public 404 (don’t put this inside ProtectedRoute)
      { path: "not-found", element: <NotFound /> },
      { path: "*", element: <Navigate to="/not-found" replace /> },
    ],
  },
];


export const router = createBrowserRouter(routes);
